/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TransformConfigDto
 */
export interface TransformConfigDto {
    /**
     * 
     * @type {string}
     * @memberof TransformConfigDto
     */
    type?: string | null;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof TransformConfigDto
     */
    options?: { [key: string]: string; } | null;
}

/**
 * Check if a given object implements the TransformConfigDto interface.
 */
export function instanceOfTransformConfigDto(value: object): value is TransformConfigDto {
    return true;
}

export function TransformConfigDtoFromJSON(json: any): TransformConfigDto {
    return TransformConfigDtoFromJSONTyped(json, false);
}

export function TransformConfigDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TransformConfigDto {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'] == null ? undefined : json['type'],
        'options': json['options'] == null ? undefined : json['options'],
    };
}

export function TransformConfigDtoToJSON(json: any): TransformConfigDto {
    return TransformConfigDtoToJSONTyped(json, false);
}

export function TransformConfigDtoToJSONTyped(value?: TransformConfigDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'options': value['options'],
    };
}

